import api from './axios';

export const getAllIbans = async () => {
    try {
        const response = await api.post("api/IBAN/ibans");
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "IBAN listesi alınamadı!" };
    }
};

export const addIban = async (data) => {
    try {
        const response = await api.post("api/IBAN/iban-add", data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "IBAN eklenemedi!" };
    }
};

export const updateIban = async (id, data) => {
    try {
        const response = await api.put(`api/IBAN/iban-update/${id}`, data);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "IBAN güncellenemedi!" };
    }
};

export const deleteIban = async (id) => {
    try {
        const response = await api.delete(`api/IBAN/iban-delete/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "IBAN silinemedi!" };
    }
};
